(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('LogisticsFormController', LogisticsFormController);

    LogisticsFormController.$inject = [
        'ordersService',
        '$stateParams',
        'genericDataService',
        '$rootScope',
        '$state',
        '$filter',
        'ModalService',
        '$templateCache',
        'reportService',
        'notificationService',
        '$q',
        '$scope',
        'userService',
        '$timeout',
        'simpleModalService',
        'preferences',
        'zonaService',
        'common'
    ];

    /* jshint maxstatements:false */
    /* jshint maxparams:false */
    function LogisticsFormController(
        ordersService,
        $stateParams,
        genericDataService,
        $rootScope,
        $state,
        $filter,
        ModalService,
        $templateCache,
        reportService,
        notificationService,
        $q,
        $scope,
        userService,
        $timeout,
        simpleModalService,
        preferences,
        zonaService,
        common
    ) {

        /* PRIVATE VARIABLES */
        var orderId = $stateParams.id;
        var modalTemplate = $templateCache.get('app/views/modals/logisticFormTemplate.html');
        var needToRetarifar = false;
        var preloadOrder = $stateParams.preload;

        /* PUBLIC VARIABLES */
        var vm = this;

        /* PUBLIC FUNCTIONS */

        var defaultVal = {};

        vm.firstTime = true; 
        vm.preferences = preferences;
        vm.reportService = reportService;
        vm.stateParams = $stateParams;
        vm.orden = {
            lineasOrdenParada: [],
            logOrderList: [],
            orderZonaRecId: '',
            orderZonaRec: '',
            orderZonaEntId: '',
            orderZonaEnt: ''
        };

        vm.genericData = {
            empresas: { list: [] },
            clients: {
                list: [],
                icons: {
                    0: 'content/img/aseguradoras/asitur/asitur-imagotipo.png',
                    1: 'content/img/aseguradoras/racc/racc-imagotipo.png',
                    2: 'content/img/aseguradoras/mapfre/mapfre-imagotipo.png',
                    3: 'content/img/aseguradoras/europ/europ-imagotipo.png',
                    4: 'content/img/aseguradoras/mm/mm-imagotipo.png',
                    5: 'content/img/aseguradoras/race/race-imagotipo.png',
                    6: 'content/img/aseguradoras/allianz/allianz-imagotipo.png',
                    7: 'content/img/aseguradoras/pelayo/pelayo-imagotipo.png',
                    8: 'content/img/aseguradoras/ld/ld-imagotipo.png',
                }
            },
            tiposOrden: {
                list: [],
            },
            tiposRecogida: {
                list: [
                    { id: 'U', nombre: 'Ubicación', showField: true },
                    { id: 'D', nombre: 'Dirección', showField: false },
                    { id: 'B', nombre: 'Base', showField: true },
                    { id: 'P', nombre: 'Parking', showField: false },
                    { id: 'T', nombre: 'Taller', showField: true }
                ]
            },
            tiposEntrega: {
                list: [
                    { id: 'U', nombre: 'Ubicación', showField: true },
                    { id: 'D', nombre: 'Dirección', showField: false },
                    { id: 'B', nombre: 'Base', showField: true },
                    { id: 'T', nombre: 'Taller', showField: true }
                ]
            },
            bases: { list: [] },
            talleres: { list: [] },
            ubicaciones: { list: [] },
            zonas: { list: [], loading: false },
            paises: { list: [] },
            provinces: {
                recogida: { list: [] },
                entrega: { list: [] }
            },
            poblaciones: {
                recogida: { list: [] },
                entrega: { list: [] }
            },
            tarifas: { list: [] },
            productos: { list: [] },
            formasPago: { list: [] }
        };

        vm.estadoFac = {
            0: 'Pendiente finalización',
            1: 'Pendiente valoracion',
            2: 'Valorado',
            3: 'Facturado',
            99: 'No facturable'
        };
        vm.estado = {
            null: 'Sin especificar',
            0: 'Pte. Asignar',
            1: 'Asignado',
            2: 'Aceptado',
            3: 'Rechazado',
            4: 'Iniciado',
            5: 'Localizado',
            6: 'Entregado',
            10: 'Finalizado',
            11: 'Ocupado',
            12: 'Desconectado',
            colors: {
                0: 'green',
                1: 'red',
                2: 'blue',
                3: 'burdeos',
                4: 'orange',
                5: 'yellow',
                6: 'violet',
                10: 'black'
            }
        };
        vm.dates = {
            orden: Date.NewDate()
        };
        vm.observaciones = {
            obs: {
                list: [],
                add: null
            },
            internas: {
                list: [],
                add: null
            },
            cliente: {
                list: [],
                add: null
            }
        };
        vm.orderList = [];
        vm.selectedOrder = {};
        vm.orderEdit = null;
        vm.orderNew = {};
        vm.keepRecData = false;
        vm.keepEntData = false;

        vm.lastActLogRec = null;
        vm.lastActLogEnt = null;
        vm.orderIdCount = 0;

        vm.showNewOrderForm = false;
        vm.tab = $rootScope.tabManager.tabs[$rootScope.tabManager.indexOfName('logistica')];
        vm.linea = {};


        vm.onCompanyChange = onCompanyChange;
        vm.onClientChange = onClientChange;
        vm.onTarifaChange = onTarifaChange;
        vm.onProductoChange = onProductoChange;
        vm.onPaisEntChange = onPaisEntChange;
        vm.onPaisRecChange = onPaisRecChange;
        vm.onProvEntChange = onProvEntChange;
        vm.onProvRecChange = onProvRecChange;
        vm.onBaseEntSelected = onBaseEntSelected;
        vm.onBaseRecSelected = onBaseRecSelected;
        vm.onTallerEntSelected = onTallerEntSelected;
        vm.onTallerRecSelected = onTallerRecSelected;
        vm.onUbicacionEntSelected = onUbicacionEntSelected;
        vm.onUbicacionRecSelected = onUbicacionRecSelected;
        vm.showField = showField;
        vm.showNewVehicleModal = showNewVehicleModal;
        vm.addVehicle = addVehicle;
        vm.saveVehicle = saveVehicle;
        vm.getRecDate = getRecDate;
        vm.getEntDate = getEntDate;
        vm.save = save;
        vm.saveAndClose = saveAndClose;
        vm.saveAndNew = saveAndNew;
        vm.isEditar = isEditar;
        vm.onEntDirChange = onEntDirChange;
        vm.onRecDirChange = onRecDirChange;
        vm.deleteVehicle = deleteVehicle;
        vm.deleteEntData = deleteEntData;
        vm.deleteRecData = deleteRecData;
        /* PUBLIC FUNCTIONS */
        vm.isEditar = isEditar;
        vm.addObservacion = addObservacion;
        vm.save = save;
        vm.saveAndClose = saveAndClose;
        vm.saveAndNew = saveAndNew;
        vm.remove = remove;
        vm.print = print;
        vm.addLineaOrden = addLineaOrden;
        vm.removeLineaOrden = removeLineaOrden;
        vm.changeStatus = changeStatus;
        vm.onClientChange = onClientChange;
        vm.onTarifaChange = onTarifaChange;
        vm.showField = showField;
        vm.callRetarifar = callRetarifar;
        vm.recalcularTotal = recalcularTotal;
        vm.calcular = calcular;
        vm.effectClass = effectClass;
        vm.onClientTryChange = onClientTryChange;
        vm.onAddressChangeRec = onAddressChangeRec;
        vm.onAddressChangeEnt = onAddressChangeEnt;

        vm.showEditIcon = showEditIcon;
        vm.hideEditIcon = hideEditIcon;
        vm.showEditIconValue = false;

        vm.accionSaveList = [
            {
                accionTexto: 'Guardar y cerrar',
                accion: vm.saveAndClose,
                selected: computeValueAccionSelected('guardarCerrar')
            },
            {
                accionTexto: 'Guardar y nuevo',
                accion: vm.saveAndNew,
                selected: computeValueAccionSelected('saveAndNew')
            },
            {
                accionTexto: 'Guardar',
                accion: vm.save,
                selected: computeValueAccionSelected('save')
            }
        ];

        vm.selectedReport = reportService.listReports(vm.orden.orderTipo).default;

        vm.isNewForm = orderId == null;


        /* INITIALIZER */
        (function () {
            $timeout(function () { getGenericData(); }, 0);
            if (!vm.isNewForm) {
                var p = ordersService.getOrderLogById(orderId)
                    .then(function (res) {
                        vm.orden = res.data;

                        setDates();
                        setObservaciones();                        
                    });
                var p2 = ordersService.getOrdenLineas(orderId)
                    .then(function (res) {
                        vm.lineasOrden = res.data;
                    });
                //getLineasImpuesto(orderId);
            }
            //New Order
            else {
                //setCombosInitialDataDefault();
                //vm.changeStatus(null);
                defaultValues();
                if (preloadOrder) {
                    preLoad();
                }
            }
            //Wait for the next digest cycle for the page to render so onChange events can trigger
        })();


        $scope.$watch('orderForm.$dirty', function (isDirty) {
            vm.tab.modified = isDirty;
        });

        function isEditar() {
            return orderId != null;
        }

        /* FUNCTION DEFINITIONS */
        function onCompanyChange() {
            var c = vm.orden.empresaId;
            getClients(c);
        }

        function onClientChange() {
            var client = vm.orden.clienteId;
            var paisEnt = vm.orden.orderPaisEntId;
            var paisRec = vm.orden.orderPaisRecId;
            var provEnt = vm.orden.orderProvEntId;
            var provRec = vm.orden.orderProvRecId;
            getPaises(client);
            getTarifas(client);
            getProvinciasEntrega(client, paisEnt);
            getProvinciasRecogida(client, paisRec);
            getPoblacionesEntrega(client, provEnt);
            getPoblacionesRecogida(client, provRec);
            getUbicaciones(client);

            if (needToRetarifar && vm.orden.orderEstadoFac >= 2) { //Está valorado
                doSave().then(function () {
                    vm.tab.modified = false;
                    doRetarifar();
                });
                needToRetarifar = false;
            }
        }

        function onTarifaChange() {
            var tarifa = vm.genericData.tarifas.selected && vm.genericData.tarifas.selected.id;
            getProductos(tarifa);
            getProductoTarifas();
        }

        function onProductoChange() {
            getProductoTarifas();
        }

        function onPaisEntChange() {
            var client = vm.orden.clienteId;
            var pais = vm.orden.orderPaisEntId;
            getProvinciasEntrega(client, pais);
        }

        function onPaisRecChange() {
            var client = vm.orden.clienteId;
            var pais = vm.orden.orderPaisRecId;
            getProvinciasRecogida(client, pais);
        }

        function onProvEntChange() {
            var cient = vm.orden.clienteId;
            var prov = vm.orden.orderProvEntId;
            getPoblacionesEntrega(cient, prov);
        }

        function onProvRecChange() {
            var cient = vm.orden.clienteId;
            var prov = vm.orden.orderProvRecId;
            getPoblacionesRecogida(cient, prov);
        }

        function onBaseEntSelected() {
            var baseId = vm.orden.baseEntId;
            if (baseId === null || vm.genericData.bases.list === null) { return; }
            var base = $filter('filter')(vm.genericData.bases.list, { id: baseId })[0];
            if (base === null) { return; }
            vm.orden.orderPaisEntId = base.paisId;
            vm.orden.orderPaisEnt = base.pais;
            vm.orden.orderProvEntId = base.provinciaId;
            vm.orden.orderProvEnt = base.provincia;
            vm.orden.orderPobEntId = base.poblacionId;
            vm.orden.orderPobEnt = base.poblacion;
            vm.orden.orderCpEnt = base.cp;
            vm.orden.orderDirEnt = base.direccion;
            vm.orden.orderLatEnt = base.latitud;
            vm.orden.orderLongEnt = base.longitud;
            vm.orden.orderTfnoEnt = base.telefono;
            vm.orden.dUbicacionEnt = base.nombre;
        }

        function onBaseRecSelected() {
            var baseId = vm.orden.baseRecId;
            if (baseId === null || vm.genericData.bases.list === null) { return; }
            var base = $filter('filter')(vm.genericData.bases.list, { id: baseId })[0];
            if (base === null) { return; }
            vm.orden.orderPaisRecId = base.paisId;
            vm.orden.orderPaisRec = base.pais;
            vm.orden.orderProvRecId = base.provinciaId;
            vm.orden.orderProvRec = base.provincia;
            vm.orden.orderPobRecId = base.poblacionId;
            vm.orden.orderPobRec = base.poblacion;
            vm.orden.orderCpRec = base.cp;
            vm.orden.orderDirRec = base.direccion;
            vm.orden.orderLatRec = base.latitud;
            vm.orden.orderLongRec = base.longitud;
            vm.orden.orderTfnoRec = base.telefono;
            vm.orden.dUbicacionRec = base.nombre;
        }

        function onTallerEntSelected() {
            var tallerId = vm.orden.tallerEntId;
            if (tallerId === null || vm.genericData.talleres.list === null) { return; }
            var taller = $filter('filter')(vm.genericData.talleres.list, { id: tallerId })[0];
            if (taller === null) { return; }
            vm.orden.orderPaisEntId = taller.paisId;
            vm.orden.orderPaisEnt = taller.pais;
            vm.orden.orderProvEntId = taller.provinciaId;
            vm.orden.orderProvEnt = taller.provincia;
            vm.orden.orderPobEntId = taller.poblacionId;
            vm.orden.orderPobEnt = taller.poblacion;
            vm.orden.orderCpEnt = taller.cp;
            vm.orden.orderDirEnt = taller.direccion;
            vm.orden.orderLatEnt = taller.latitud;
            vm.orden.orderLongEnt = taller.longitud;
            vm.orden.orderTfnoEnt = taller.telefono;
            vm.orden.dUbicacionEnt = taller.nombre;
        }

        function onTallerRecSelected() {
            var tallerId = vm.orden.tallerRecId;
            if (tallerId === null || vm.genericData.talleres.list === null) { return; }
            var taller = $filter('filter')(vm.genericData.talleres.list, { id: tallerId })[0];
            if (taller === null) { return; }
            vm.orden.orderPaisRecId = taller.paisId;
            vm.orden.orderPaisRec = taller.pais;
            vm.orden.orderProvRecId = taller.provinciaId;
            vm.orden.orderProvRec = taller.provincia;
            vm.orden.orderPobRecId = taller.poblacionId;
            vm.orden.orderPobRec = taller.poblacion;
            vm.orden.orderCpRec = taller.cp;
            vm.orden.orderDirRec = taller.direccion;
            vm.orden.orderLatRec = taller.latitud;
            vm.orden.orderLongRec = taller.longitud;
            vm.orden.orderTfnoRec = taller.telefono;
            vm.orden.dUbicacionRec = taller.nombre;
        }

        function onUbicacionEntSelected() {
            var ubicacionId = vm.orden.ubicacionEntId;
            if (ubicacionId === null || vm.genericData.ubicaciones.list === null) { return; }
            var ubicacion = $filter('filter')(vm.genericData.ubicaciones.list, { id: ubicacionId })[0];
            if (ubicacion === null) { return; }
            vm.orden.orderPaisEntId = ubicacion.paisId;
            vm.orden.orderPaisEnt = ubicacion.pais;
            vm.orden.orderProvEntId = ubicacion.provinciaId;
            vm.orden.orderProvEnt = ubicacion.provincia;
            vm.orden.orderPobEntId = ubicacion.poblacionId;
            vm.orden.orderPobEnt = ubicacion.poblacion;
            vm.orden.orderCpEnt = ubicacion.cp;
            vm.orden.orderDirEnt = ubicacion.direccion;
            vm.orden.orderLatEnt = ubicacion.latitud;
            vm.orden.orderLongEnt = ubicacion.longitud;
            vm.orden.orderTfnoEnt = ubicacion.telefono;
            vm.orden.dUbicacionEnt = ubicacion.nombre;
        }

        function onUbicacionRecSelected() {
            var ubicacionId = vm.orden.ubicacionRecId;
            if (ubicacionId === null || vm.genericData.ubicaciones.list === null) { return; }
            var ubicacion = $filter('filter')(vm.genericData.ubicaciones.list, { id: ubicacionId })[0];
            if (ubicacion === null) { return; }
            vm.orden.orderPaisEntId = ubicacion.paisId;
            vm.orden.orderPaisEnt = ubicacion.pais;
            vm.orden.orderProvEntId = ubicacion.provinciaId;
            vm.orden.orderProvEnt = ubicacion.provincia;
            vm.orden.orderPobEntId = ubicacion.poblacionId;
            vm.orden.orderPobEnt = ubicacion.poblacion;
            vm.orden.orderCpRec = ubicacion.cp;
            vm.orden.orderDirRec = ubicacion.direccion;
            vm.orden.orderLatRec = ubicacion.latitud;
            vm.orden.orderLongRec = ubicacion.longitud;
            vm.orden.orderTfnoRec = ubicacion.telefono;
            vm.orden.dUbicacionRec = ubicacion.nombre;
        }

        var lastRecDir = null;
        function onRecDirChange() {
            if (lastRecDir === null) { lastRecDir = vm.orden.orderDirRec; }

            if (vm.orden.dUbicacionRec === null || typeof vm.orden.dUbicacionRec === 'undefined' || 
                vm.orden.dUbicacionRec === '' || vm.orden.dUbicacionRec === lastRecDir) {
                vm.orden.dUbicacionRec = vm.orden.orderDirRec;
            }

            lastRecDir = vm.orden.orderDirRec;
        }

        var lastEntDir = null;
        function onEntDirChange() {
            if (lastEntDir === null) { lastEntDir = vm.orden.orderDirEnt; }

            if (vm.orden.dUbicacionEnt === undefined || vm.orden.dUbicacionEnt === null ||
                vm.orden.dUbicacionEnt === '' || vm.orden.dUbicacionEnt === lastEntDir) {
                vm.orden.dUbicacionEnt = vm.orden.orderDirEnt;
            }

            lastEntDir = vm.orden.orderDirEnt;
        }

        function onAddressChangeRec(address) {
            if (!common.isNullOrUndefined(vm.orden.orderLatRec) && !common.isNullOrUndefined(vm.orden.orderLongRec)) {
                zonaService.pointInZone(vm.orden.orderLatRec, vm.orden.orderLongRec).then(function (res) {
                    if (res.data.isInZone) {
                        vm.orden.zonaRecId = res.data.zoneId;
                        vm.orden.zonaRec = res.data.description;
                    }
                });
            }
        }

        function onAddressChangeEnt(address) {
            if (!common.isNullOrUndefined(vm.orden.orderLatEnt) && !common.isNullOrUndefined(vm.orden.orderLongEnt)) {
                zonaService.pointInZone(vm.orden.orderLatEnt, vm.orden.orderLongEnt).then(function (res) {
                    if (res.data.isInZone) {
                        vm.orden.orderZonaEntId = res.data.zoneId;
                        vm.orden.orderZonaEnt = res.data.description;
                    }
                });
            }
        }

        /* PRIVATE FUNCTIONS */
        function getGenericData() {
            var promises = [];

            if(vm.isNewForm) defaultValues();

            vm.genericData.empresas.loading = true;
            promises.push(genericDataService.getEmpresas()
                .then(function (res) {
                    vm.genericData.empresas.loading = false;
                    vm.genericData.empresas.list = res;

                    if (vm.orden.empresaId == null) {
                        vm.orden.empresaId = vm.genericData.empresas.list[0].id;
                        //defaultVal.empresa = false;
                    }
                    else vm.genericData.empresas.selected = vm.genericData.empresas.list.find(x => x.id == vm.orden.empresaId);

                })
            );

            vm.genericData.bases.loading = true;
            promises.push(genericDataService.getBases()
                .then(function (res) {
                    vm.genericData.bases.loading = false;
                    vm.genericData.bases.list = res;
                })
            );

            vm.genericData.talleres.loading = true;
            promises.push(genericDataService.getTalleres()
                .then(function (res) {
                    vm.genericData.talleres.loading = false;
                    vm.genericData.talleres.list = res;
                })
            );

            vm.genericData.formasPago.loading = true;
            promises.push(genericDataService.getTiposPago()
                .then(function (res) {
                    vm.genericData.formasPago.loading = false;
                    vm.genericData.formasPago.list = res;
                })
            );

            vm.genericData.tiposOrden.loading = true;
            promises.push(genericDataService.getTiposOrdenLog()
                .then(function (res) {
                    vm.genericData.tiposOrden.loading = false;
                    vm.genericData.tiposOrden.list = res;
                })
            );

            vm.genericData.zonas.loading = true;
            promises.push(zonaService.getList()
                .then(function (res) {
                    vm.genericData.zonas.loading = false;
                    vm.genericData.zonas.list = res.data.list;
                })
            );

            return $q.all(promises);
        }

        function getClients(company) {
            if (company == null) { vm.genericData.clients.list = null; }
            else {
                vm.genericData.clients.loading = true;
                genericDataService.getClients(company)
                    .then(function (res) {
                        vm.genericData.clients.loading = false;
                        vm.genericData.clients.list = res;

                        if (vm.firstTime && vm.orden.clienteId != null) {
                            vm.genericData.clients.selected = vm.genericData.clients.list.find(x => x.id == vm.orden.clienteId);
                            
                            vm.firstTime = false;
                        }
                        else vm.genericData.clients.selected = null; 

                    });
            }
        }

        function getTarifas(clientId) {
            if (clientId == null) {
                vm.genericData.tarifas.list = null;
                vm.genericData.tarifas.selected = { id: null, nombre: null };
                return;
            }
            var type = vm.orden.orderTipo === 0 ? 'GRU' : 'LOG';

            vm.genericData.tarifas.loading = true;
            genericDataService.getTarifas(clientId, type)
                .then(function (res) {
                    vm.genericData.tarifas.loading = false;
                    vm.genericData.tarifas.list = res;
                });
        }

        function getProductos(tarifaId) {
            if (tarifaId == null) {
                vm.genericData.productos.list = null;
                vm.genericData.productos.selected = { id: null, nombre: null };
                return;
            }
            vm.genericData.productos.loading = true;
            genericDataService.getProductos(tarifaId)
                .then(function (res) {                    
                    vm.genericData.productos.loading = false;
                    vm.genericData.productos.list = res;
                });
        }

        // Get the country data -> DEPENDS ON: client
        function getPaises(clientId) {
            vm.genericData.paises.loading = true;
            genericDataService.getPaises(clientId)
                .then(function (res) {
                    vm.genericData.paises.loading = false;
                    vm.genericData.paises.list = res;
                });
        }

        // Get the delivery provinces data -> DEPENDS ON: client, delivery country
        function getProvinciasEntrega(clientId, pais) {
            if (pais == null) {
                vm.genericData.provinces.entrega.list = null;
            } else {
                vm.genericData.provinces.entrega.loading = true;
                genericDataService.getProvinces(clientId, pais)
                    .then(function (res) {
                        vm.genericData.provinces.entrega.loading = false;
                        vm.genericData.provinces.entrega.list = res;
                    });
            }
        }

        // Get the pickup provinces data -> DEPENDS ON: client, pickup country
        function getProvinciasRecogida(clientId, pais) {
            if (pais == null) {
                vm.genericData.provinces.recogida.list = null;
            } else {
                vm.genericData.provinces.recogida.loading = true;
                genericDataService.getProvinces(clientId, pais)
                    .then(function (res) {
                        vm.genericData.provinces.recogida.loading = false;
                        vm.genericData.provinces.recogida.list = res;
                    });
            }
        }

        // Get the delivery populations data -> DEPENDS ON: client, delivery province
        function getPoblacionesEntrega(clientId, provincia) {
            if (provincia == null) {
                vm.genericData.poblaciones.entrega.list = null;
            }
            else {
                vm.genericData.poblaciones.entrega.loading = true;
                genericDataService.getPopulations(clientId, provincia)
                    .then(function (res) {
                        vm.genericData.poblaciones.entrega.loading = false;
                        vm.genericData.poblaciones.entrega.list = res;
                    });
            }
        }

        // Get the pickup populations data -> DEPENDS ON: client, pickup province
        function getPoblacionesRecogida(clientId, provincia) {
            if (provincia == null) {
                vm.genericData.poblaciones.recogida.list = null;
            } else {
                vm.genericData.poblaciones.recogida.loading = true;
                genericDataService.getPopulations(clientId, provincia)
                    .then(function (res) {
                        vm.genericData.poblaciones.recogida.loading = false;
                        vm.genericData.poblaciones.recogida.list = res;
                    });
            }
        }

        // Get the places data -> DEPENDS ON: client
        function getUbicaciones(clientId) {
            if (clientId == null) {
                vm.genericData.ubicaciones.list = null;
                return;
            }
            vm.genericData.ubicaciones.loading = true;
            genericDataService.getUbicaciones(clientId)
                .then(function (res) {
                    vm.genericData.ubicaciones.loading = false;
                    vm.genericData.ubicaciones.list = res;
                });
        }

        function getProductoTarifas() {
            var tarifaId = vm.genericData.tarifas.selected && vm.genericData.tarifas.selected.id;
            var productoId = vm.genericData.productos.selected && vm.genericData.productos.selected.id;
            if (!tarifaId || !productoId) { return; }
            genericDataService.tarifaProducto(tarifaId, productoId)
                .then(function (res) {
                    vm.linea.lineaOrdenCantidad = 1;
                    vm.linea.lineaOrdenPrecio = res.precio;
                    vm.linea.lineaOrdenDescuento = res.porcentaje;
                    vm.linea.lineaOrdenDesc = vm.genericData.productos.selected.nombre;
                    recalcularTotal();
                });
        }

        function getLineasImpuesto(orderId) {
            ordersService.getLineasImpuesto(orderId)
                .then(function (res) {
                    vm.lineasImpuesto = res.data;
                });
        }

        function showField(tipo, id) {
            if (id == null) { return false; }
            if (tipo === 'ent') {
                return $filter('filter')(vm.genericData.tiposEntrega.list, { id: id })[0].showField;
            } else {
                return $filter('filter')(vm.genericData.tiposRecogida.list, { id: id })[0].showField;
            }
        }

        function defaultValues() {
            vm.orden.orderEstado = 0;
            vm.orden.orderGruTipoRec = 'D';
            vm.orden.orderGruTipoEnt = 'D';
        }

        function setObservaciones() {
            //Observaciones
            parseObservaciones(vm.observaciones.obs, vm.orden.orderObs);
            //Observaciones internas
            parseObservaciones(vm.observaciones.internas, vm.orden.orderObsInt);
            //Observaciones cliente
            parseObservaciones(vm.observaciones.cliente, vm.orden.orderObsCliente);
        }

        function parseObservaciones(obs, data) {
            if (data == null) {
                obs.list = [];
            } else {
                try { obs.list = JSON.parse(data); }
                catch (e) {
                    data = JSON.stringify([{ text: data }]);
                    obs.list = JSON.parse(data);
                }
            }
        }

        function showNewVehicleModal(vehicle) {
            ModalService.showModal({
                template: modalTemplate,
                controller: function ($scope, close) {
                    var modal = this;
                    modal.vm = vm;

                    modal.isEdit = false;
                  

                    modal.reset = function () {

                        modal.vehicleModels.loading = true;
                        genericDataService.getVehicleModel()
                            .then(function (res) {
                                modal.vehicleModels.loading = false;
                                modal.vehicleModels.list = res;
                            });

                        modal.vehicleBrands.loading = true;
                        genericDataService.getVehicleBrands()
                            .then(function (res) {
                                modal.vehicleBrands.loading = false;
                                modal.vehicleBrands.list = res;
                            });

                        modal.vehicleColors.loading = true;
                        genericDataService.getVehicleColors()
                            .then(function (res) {
                                modal.vehicleColors.loading = false;
                                modal.vehicleColors.list = res;
                            });

                        modal.tiposVehiculo.loading = true;
                        genericDataService.getTiposVhc(vm.orden.clienteId)
                            .then(function (res) {
                                modal.tiposVehiculo.loading = false;
                                modal.tiposVehiculo.list = res;

                                if (modal.isEdit == false) modal.tiposVehiculo.selected = modal.tiposVehiculo.list.find(item => item.id == 12);
                                else {
                                    var temp = modal.tiposVehiculo.list.find(item => item.id == modal.vehicle.tipoVhcId);
                                    if (temp) modal.tiposVehiculo.selected = temp;
                                    else {
                                        modal.tiposVehiculo.selected = modal.tiposVehiculo.list.find(item => item.id == 12);
                                    }
                                }

                            });
                    };

                    modal.onModelChange = function () {
                        if (modal.vehicle.orderGruModeloId === undefined ||
                            modal.vehicle.orderGruModeloId === null) {
                            return;
                        }

                        var models = $filter('filter')(modal.vehicleModels.list, { id: modal.vehicle.orderGruModeloId });
                        if (models.length > 0) {
                            var brands = $filter('filter')(modal.vehicleBrands.list, { id: models[0].marcaId });
                            if (brands.length > 0) {
                                modal.vehicle.orderGruMarcaId = brands[0].id;
                            }
                        }
                    };
                    modal.close = function () {
                        close();
                    };
                    modal.saveClose = function () {
                        modal.setDates();
                        vm.addVehicle(modal.vehicle);
                        close(modal.vehicle);
                    };
                    modal.saveNew = function () {
                        modal.setDates();
                        vm.addVehicle(modal.vehicle);
                        modal.vehicle = {
                            orderDateRec: modal.vehicle.orderDateRec,
                            orderDateEnt: modal.vehicle.orderDateEnt,
                            tfnoFirmaRecogida: modal.vehicle.tfnoFirmaRecogida,
                            nombreFirmaRecogida: modal.vehicle.nombreFirmaRecogida,
                            nombreFirmaEntrega: modal.vehicle.nombreFirmaEntrega,
                            tfnoFirmaEntrega: modal.vehicle.tfnoFirmaEntrega, 
                        };

                        modal.reset();

                        document.getElementById('plate-input').focus();
                    };

                    modal.setDates = function () {
                        modal.vehicle.tipoVhcId = modal.tiposVehiculo.selected.id; 
                        modal.vehicle.orderDate = modal.dates.recPrev;
                        modal.vehicle.orderFechaLimiteEnt = modal.dates.entPrev;
                        modal.vehicle.orderDateRec = modal.dates.recPrev;
                        modal.vehicle.orderDateEnt = modal.dates.entPrev;
                    };

                    modal.updateVehicle = function () {
                        modal.vehicle.tipoVhcId = modal.tiposVehiculo.selected.id; 
                        vm.saveVehicle(modal.vehicle);
                        close(modal.vehicle);
                    };

                    //Lists
                    modal.vehicleModels = { list: [] };
                    modal.vehicleBrands = { list: [] };
                    modal.vehicleColors = { list: [] };
                    modal.tiposVehiculo = { list: [] };
                    modal.dates = {};

                    //initialize
                    if (vehicle) {
                        modal.isEdit = true;
                        modal.vehicle = $.extend(modal.vehicle, vehicle);
                        modal.dates.recPrev = vehicle.orderDate && new Date(vehicle.orderDate);
                        modal.dates.entPrev = vehicle.orderFechaLimiteEnt && new Date(vehicle.orderFechaLimiteEnt);

                    } else {
                        modal.vehicle = {};
                        modal.dates.recPrev = Date.NewDate();
                    }

                    modal.reset();
                },
                controllerAs: 'modal'
            });
        }

        function addVehicle(v) {            
            var id = 0;

            vm.orden.logOrderList.forEach(element => {
                if (element.listId >= id) { id = element.listId + 1; }
            });

            v.listId = id;

            v.orderDate = v.orderDateRec;
            v.orderFechaLimiteEnt = v.orderDateEnt;

            vm.orden.logOrderList.push(v);


            vm.orden.lineasOrdenParada.push({
                actLogList: [{
                    actLogFecha: v.orderDateEnt,
                    actLogTipo: 1,
                    actLogOrdenListId: id
                }]
            });
            vm.orden.lineasOrdenParada.push({
                actLogList: [{
                    actLogFecha: v.orderDateRec,
                    actLogTipo: 0,
                    actLogOrdenListId: id
                }]
            });
        }

        function deleteVehicle(v) {

            simpleModalService.yesNoModal('Confirmación eliminar',
                '¿Desea eliminar el vehículo?')
                .then(function (result) {
                    if (result) {
                        var id = v.listId;

                        var lopIndexes = [];
                        for (let i = 0; i < vm.orden.lineasOrdenParada.length; i++) {
                            var lop = vm.orden.lineasOrdenParada[i];
                            var indexes = [];
                            for (let j = 0; j < lop.actLogList.length; j++) {
                                if (lop.actLogList[j].actLogOrdenListId === id) {
                                    indexes.push(j);
                                }
                            }
                            for (let k = indexes.length - 1; k >= 0; k--) {
                                lop.actLogList.splice(indexes[k], 1);
                            }

                            if (lop.actLogList.length <= 0) { lopIndexes.push(i); }
                        }

                        for (let i = lopIndexes.length - 1; i >= 0; i--) {
                            vm.orden.lineasOrdenParada.splice(lopIndexes[i], 1);
                        }

                        var ordIndexes = [];
                        for (let i = 0; i < vm.orden.logOrderList.length; i++) {
                            if (vm.orden.logOrderList[i].listId === id) {
                                ordIndexes.push(i);
                            }
                        }
                        for (let i = ordIndexes.length - 1; i >= 0; i--) {
                            vm.orden.logOrderList.splice(ordIndexes[i], 1);
                        }
                    }
                });

           
        }

        function saveVehicle(v) {
            var id = v.listId;

            vm.orden.logOrderList.forEach(element => {
                if (element.listId === v.listId) {
                    Object.assign(element, v);
                }
            });

            vm.orden.lineasOrdenParada.forEach(element => {
                element.actLogList.forEach(actLog => {
                    if (actLog.actLogTipo === 0 && actLog.actLogOrdenListId === id) {
                        actLog.actLogFecha = v.orderDateRec;
                    }
                    if (actLog.actLogTipo === 1 && actLog.actLogOrdenListId === id) {
                        actLog.actLogFecha = v.orderDateEnt;
                    }
                });
            });
        }

        function populateVehicle(v) {
            v.empresaId = vm.orden.empresaId;
            v.clienteId = vm.orden.clienteId;

            v.baseRecId = vm.orden.baseRecId;
            v.baseEntId = vm.orden.baseEntId;

            v.tallerEntId = vm.orden.tallerEntId;
            v.tallerRecId = vm.orden.tallerRecId;

            v.ubicacionEntId = vm.orden.ubicacionEntId;
            v.ubicacionRecId = vm.orden.ubicacionRecId;

            v.orderGruTipoEnt = vm.orden.orderGruTipoEnt;
            v.orderGruTipoRec = vm.orden.orderGruTipoRec;

            v.orderLatEnt = vm.orden.orderLatEnt;
            v.orderLatRec = vm.orden.orderLatRec;
            v.orderLongEnt = vm.orden.orderLongEnt;
            v.orderLongRec = vm.orden.orderLongRec;

            v.orderPaisEnt = vm.orden.orderPaisEnt;
            v.orderPaisEntId = vm.orden.orderPaisEntId;
            v.orderPaisRec = vm.orden.orderPaisRec;
            v.orderPaisRecId = vm.orden.orderPaisRecId;

            v.orderPobEnt = vm.orden.orderPobEnt;
            v.orderPobEntId = vm.orden.orderPobEntId;
            v.orderPobRec = vm.orden.orderPobRec;
            v.orderPobRecId = vm.orden.orderPobRecId;

            v.orderProvEnt = vm.orden.orderProvEnt;
            v.orderProvEntId = vm.orden.orderProvEntId;
            v.orderProvRec = vm.orden.orderProvRec;
            v.orderProvRecId = vm.orden.orderProvRecId;

            v.orderDirEnt = vm.orden.orderDirEnt;
            v.orderDirRec = vm.orden.orderDirRec;

            v.dUbicacionRec = vm.orden.dUbicacionRec;
            v.dUbicacionEnt = vm.orden.dUbicacionEnt;

            v.orderCpEnt = vm.orden.orderCpEnt;
            v.orderCpRec = vm.orden.orderCpRec;
        }

        function getRecDate(id) {
            var date = null;
            vm.orden.lineasOrdenParada.forEach(element => {
                element.actLogList.forEach(actLog => {
                    if (actLog.actLogTipo === 0 && actLog.actLogOrdenListId === id) {
                        date = actLog.actLogFecha;
                    }
                });
            });
            return date;
        }

        function getEntDate(id) {
            var date = null;
            vm.orden.lineasOrdenParada.forEach(element => {
                element.actLogList.forEach(actLog => {
                    if (actLog.actLogTipo === 1 && actLog.actLogOrdenListId === id) {
                        date = actLog.actLogFecha;
                    }
                });
            });
            return date;
        }

        function deleteRecData() {
            vm.orden.orderGruTipoRec = null;
            vm.orden.baseRecId = null;
            vm.orden.tallerRecId = null;
            vm.orden.ubicacionRecId = null;

            vm.orden.orderPaisRec = null;
            vm.orden.orderProvRec = null;
            vm.orden.orderPobRec = null;
            vm.orden.orderCpRec = null;
            vm.orden.orderLatRec = null;
            vm.orden.orderLongRec = null;
            vm.orden.orderDirRec = null;
            vm.orden.dUbicacionRec = null;
            vm.orden.orderPaisRecId = null;
            vm.orden.orderProvRecId = null;
            vm.orden.orderPobRecId = null;

            vm.orden.orderGruTipoRec = 'D';
        }

        function deleteEntData() {
            vm.orden.orderGruTipoEnt = null;
            vm.orden.baseEntId = null;
            vm.orden.tallerEntId = null;
            vm.orden.ubicacionEntId = null;

            vm.orden.orderPaisEnt = null;
            vm.orden.orderProvEnt = null;
            vm.orden.orderPobEnt = null;
            vm.orden.orderCpEnt = null;
            vm.orden.orderLatEnt = null;
            vm.orden.orderLongEnt = null;
            vm.orden.orderDirEnt = null;
            vm.orden.dUbicacionEnt = null;
            vm.orden.orderPaisEntId = null;
            vm.orden.orderProvEntId = null;
            vm.orden.orderPobEntId = null;

            vm.orden.orderGruTipoEnt = 'D';
        }

        function save() {
            for (var i = 0; i < vm.accionSaveList.length; ++i) {
                if (vm.accionSaveList[i].accionTexto === 'Guardar') { vm.accionSaveList[i].selected = true; }
                else { vm.accionSaveList[i].selected = false; }
            }

            doSave().then(function (data) {
                $rootScope.$broadcast('ReloadOrdenesActivas');
                vm.tab.modified = false;
                if (!vm.orden.orderId) {
                    $state.go('flota.logistica.editar', { 'id': data.data, 'accion': 'save' });
                }
            });
        }

        function saveAndClose() {
            doSave().then(function () {
                $rootScope.$broadcast('ReloadOrdenesActivas');
                vm.tab.modified = false;
                $state.go('flota.logistica.listado', { 'accion': 'saveAndNew' });
            });
        }

        function saveAndNew() {
            for (var i = 0; i < vm.accionSaveList.length; ++i) {
                if (vm.accionSaveList[i].accionTexto === 'Guardar y nuevo') { vm.accionSaveList[i].selected = true; }
                else { vm.accionSaveList[i].selected = false; }
            }
            doSave().then(function () {
                $rootScope.$broadcast('ReloadOrdenesActivas');
                vm.tab.modified = false;
                if (!vm.orden.orderId) {
                    $state.reload();
                } else {
                    $state.go('flota.logistica.nuevo');
                }
            });
        }

        function doSave() {
            var deferred = $q.defer();

            vm.orden.logOrderList.forEach(element => {
                populateVehicle(element);
            });

            //Lineas Orden
            if (vm.orden.lineasOrdenList != null) {
                for (var i = 0; i < vm.orden.lineasOrdenList.length; i++) {
                    vm.orden.lineasOrdenList[i].tarifaId = vm.orden.lineasOrdenList[i].tarSelected ? vm.orden.lineasOrdenList[i].tarSelected.id : null;
                    vm.orden.lineasOrdenList[i].productoId = vm.orden.lineasOrdenList[i].proSelected ? vm.orden.lineasOrdenList[i].proSelected.id : null;
                }
            }
            //VALORACION
            //vm.orden.tipoPagoId = vm.genericData.formasPago.selected.id;

            vm.orden.orderDate = vm.dates.orden;

            vm.doingSomething = true;
            if (vm.orden.orderId != null) {
                ordersService.updateOrderLog(vm.orden, vm.orden.orderId).then(
                    function (data) { //CALLBACKS
                        notificationService.sendAppNotification({
                            message: 'Orden modificada con éxito',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                        });
                        vm.doingSomething = false;
                        deferred.resolve(data);
                    }, function (data) {
                        notificationService.sendAppNotification({
                            message: 'Ha ocurrido un error al modificar la orden',
                            positionY: 'top', positionX: 'right', delay: null, type: 'error'
                        });
                        vm.doingSomething = false;
                        deferred.reject(data);
                    }
                );
            } else {
                ordersService.addOrderLog(vm.orden).then(
                    function (data) { //CALLBACKS
                        notificationService.sendAppNotification({
                            message: 'Orden creada con éxito',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                        });
                        vm.doingSomething = false;
                        deferred.resolve(data);

                    }, function (data) {
                        notificationService.sendAppNotification({
                            message: 'Ha ocurrido un error al crear la orden',
                            positionY: 'top', positionX: 'right', delay: null, type: 'error'
                        });
                        vm.doingSomething = false;
                        deferred.reject(data);
                    }
                );
            }

            return deferred.promise;
        }

        function computeValueAccionSelected(accion) {
            if (accion === vm.stateParams.accion) { return true; }
            return false;
        }

        function callRetarifar(needConfirm) {
            if (needConfirm) {
                simpleModalService.yesNoModal('Confirmación valorar', '¿Desea valorar el pedido?')
                    .then(function (result) {
                        if (result) {
                            doRetarifar();
                        }
                    });
            } else {
                doRetarifar();
            }
        }

        function doRetarifar() {
            if (!checkValorar()) { return; }
            ordersService.retarifar(orderId)
                .then(function (res) {
                    getLineasImpuesto(orderId);
                    assingValoracionData(res.data.d);
                });
        }

        function calcular() {
            ordersService.calcular(orderId, vm.orden.orderDescuento, vm.orden.orderSuplidosIncFac)
                .then(function (res) {
                    assingValoracionData(res.data.d);
                    getLineasImpuesto(orderId);
                });
        }

        function assingValoracionData(info) {
            vm.orden.baseimponible = info.baseimponible;
            vm.orden.importeimpuestos = info.importeimpuestos;
            vm.orden.suplidos = info.suplidos;
            vm.orden.importebruto = info.importebruto;
            vm.orden.total = info.total;
            vm.orden.orderEstadoFac = info.estadofac;
        }

        function checkValorar() {
            if (vm.tab.modified) {
                alert('Hay cambios sin guardar, guarde la orden para valorar.');
            }
            return !vm.tab.modified;
        }

        function remove() {
            if (vm.orden.orderId == null) { return; }
            simpleModalService.yesNoModal('Confirmación eliminar',
                '¿Desea eliminar el pedido?')
                .then(function (result) {
                    if (result) {
                        notificationService.sendAppNotification({
                            message: 'Eliminando orden...',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
                        });

                        ordersService.deleteOrderLog([vm.orden.orderId]).then(function () {
                            notificationService.sendAppNotification({
                                message: 'Orden eliminada con éxito',
                                positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                            });
                            vm.tab.modified = false;
                            $state.go('flota.logistica.listado');
                        }, function () {
                            notificationService.sendAppNotification({
                                message: 'Ha ocurrido un error al eliminar la orden',
                                positionY: 'top', positionX: 'right', delay: null, type: 'error'
                            });
                        });
                    }
                });
        }

        function removeLineaOrden(index) {
            var lineaOrdenId = vm.lineasOrden[index].lineaOrdenId;
            vm.lineasOrden.splice(index, 1);
            ordersService.removeOrdenLinea(lineaOrdenId)
                .then(function (result) {
                    //vm.linea = null;
                    vm.calcular();

                });
        }

        function addLineaOrden() {
            if (!checkValorar()) { return; }
            if (!vm.lineasOrden) { vm.lineasOrden = []; }
            if (allValuesFull()) {
                var newJson = angular.extend(vm.linea,
                    {
                        ordenId: orderId,
                        productoId: vm.genericData.productos.selected.id,
                        tarifaId: vm.genericData.tarifas.selected.id,
                        LineaOrdenTotal: vm.linea.lineaOrdenTotal,
                        productoName: vm.genericData.productos.selected.nombre,
                        tarifaDesc: vm.genericData.tarifas.selected.nombre
                    });
                vm.lineasOrden.push(newJson);
                ordersService.saveOrdenLinea(newJson)
                    .then(function (result) {
                        //vm.genericData.tarifas.selected = null;
                        vm.linea = {};
                        vm.calcular();
                        ordersService.getOrdenLineas(orderId)
                            .then(function (res) {
                                vm.lineasOrden = res.data;
                            });
                    });
            }
        }

        function recalcularTotal() {
            if (!vm.linea) { return; }
            if (vm.linea.lineaOrdenCantidad === undefined ||
                vm.linea.lineaOrdenPrecio === undefined ||
                vm.linea.lineaOrdenDescuento === undefined) { return; }

            vm.linea.lineaOrdenTotal = vm.linea.lineaOrdenCantidad * vm.linea.lineaOrdenPrecio -
                (vm.linea.lineaOrdenCantidad * vm.linea.lineaOrdenPrecio * vm.linea.lineaOrdenDescuento / 100);
        }

        function allValuesFull() {
            /*jshint maxcomplexity:false */
            if (vm.linea == null ||
                vm.genericData.tarifas.selected == null || vm.genericData.tarifas.selected.id == null ||
                vm.genericData.productos.selected == null || vm.genericData.productos.selected.id == null ||
                vm.linea.lineaOrdenDesc == null) {
                return false;
            }
            vm.linea.lineaOrdenCantidad = vm.linea.lineaOrdenCantidad ? vm.linea.lineaOrdenCantidad : 1;
            vm.linea.lineaOrdenPrecio = vm.linea.lineaOrdenPrecio ? vm.linea.lineaOrdenPrecio : 0;
            vm.linea.lineaOrdenDescuento = vm.linea.lineaOrdenDescuento ? vm.linea.lineaOrdenDescuento : 0;
            return true;
        }

        function changeStatus(status) {
            vm.orden.orderEstado = status;
        }

        function getStatusColor(status) {
            return vm.estado.colors[status] || 'undefined';
        }

        function closeTab() {
            $rootScope.tabManager.removeActiveTab();
        }

        $scope.$on('checkExitAction' + vm.tab.state, function (event, args) {
            simpleModalService.showConfirmCloseModal(doSave, vm.tab, function (t) {
                vm.tab.closeAction();
            });
        });

        function effectClass(target) {
            vm.effects = {};
            vm.effects[target] = true;
            setTimeout(function () {
                vm.effects[target] = undefined;
            }, 3000);
        }

        function addObservacion(obs, type) {
            if (!obs.add) { return; }
            obs.list.push({
                text: obs.add, time: Date.now(),
                author: userService.userData.name +
                (userService.userData.surname ? ' ' + userService.userData.surname : '')
            });
            obs.add = null;

            if (type === 'obs') {
                vm.orden.orderObs = JSON.stringify(vm.observaciones.obs.list);
            } else if (type === 'int') {
                vm.orden.orderObsInt = JSON.stringify(vm.observaciones.internas.list);
            } else if (type === 'cli') {
                vm.orden.orderObsCliente = JSON.stringify(vm.observaciones.cliente.list);
            }
        }

        function setDates() {
            vm.dates.orden = vm.orden.orderDate && new Date(vm.orden.orderDate);
        }

        function onClientTryChange() {
            return $q(function (resolve, reject) {
                if (vm.orden.orderEstadoFac >= 2) {
                    simpleModalService.yesNoModal('Confirmación cambio cliente',
                        `El servicio esta valorado, si se cambia el cliente se guardará la orden y se
					generará una valoración nueva. ¿Desea cambiar el cliente?`).then(function (result) {
                            if (result) {
                                needToRetarifar = true;
                                resolve();
                            } else {
                                needToRetarifar = false;
                                reject();
                            }
                        }, function () {
                            reject();
                        });
                } else {
                    resolve();
                }
            });
        }

        function preLoad() {
            ordersService.getOrderById(preloadOrder)
                .then(function (res) {
                    var preload = res.data;

                    vm.orden.empresaId = preload.empresaId;
                    vm.orden.clienteId = preload.clienteId;
                    vm.orden.orderLogExpediente = preload.orderLogExpediente;
                    vm.orden.orderNomConductor = preload.orderNomConductor;
                    vm.orden.orderTfnoConductor = preload.orderTfnoConductor;

                    //Datos de recogida
                    vm.orden.orderGruTipoRec = preload.orderGruTipoRec;
                    vm.orden.baseRecId = preload.baseRecId;
                    vm.orden.tallerRecId = preload.tallerRecId;
                    vm.orden.colabRecId = preload.colabRecId;
                    vm.orden.orderPaisRecId = preload.orderPaisRecId;
                    vm.orden.orderPaisRec = preload.orderPaisRec;
                    vm.orden.orderProvRecId = preload.orderProvRecId;
                    vm.orden.orderProvRec = preload.orderProvRec;
                    vm.orden.orderPobRecId = preload.orderPobRecId;
                    vm.orden.orderPobRec = preload.orderPobRec;

                    vm.orden.orderCpRec = preload.orderCpRec;
                    vm.orden.orderLatRec = preload.orderLatRec;
                    vm.orden.orderLongRec = preload.orderLongRec;
                    vm.orden.orderDirRec = preload.orderDirRec;

                    vm.orden.dUbicacionRec = preload.dUbicacionRec;

                    //Datos de entrega
                    vm.orden.orderGruTipoEnt = preload.orderGruTipoEnt;
                    vm.orden.baseEntId = preload.baseEntId;
                    vm.orden.tallerEntId = preload.tallerEntId;
                    vm.orden.colabEntId = preload.colabEntId;
                    vm.orden.orderPaisEntId = preload.orderPaisEntId;
                    vm.orden.orderPaisEnt = preload.orderPaisEnt;
                    vm.orden.orderProvEntId = preload.orderProvEntId;
                    vm.orden.orderProvEnt = preload.orderProvEnt;
                    vm.orden.orderPobEntId = preload.orderPobEntId;
                    vm.orden.orderPobEnt = preload.orderPobEnt;

                    vm.orden.orderCpEnt = preload.orderCpEnt;
                    vm.orden.orderLatEnt = preload.orderLatEnt;
                    vm.orden.orderLongEnt = preload.orderLongEnt;
                    vm.orden.orderDirEnt = preload.orderDirEnt;

                    vm.orden.dUbicacionEnt = preload.dUbicacionEnt;

                    vm.orden.orderObs = preload.orderObs;
                    vm.orden.orderObsInt = preload.orderObsInt;
                    vm.orden.orderObsCliente = preload.orderObsCliente;

                    setDates();
                    setObservaciones();

                    vm.dates.orden = Date.NewDate();
                });
        }

        function showEditIcon(e) {
            vm.showEditIconValue = true;
        }

        function hideEditIcon(e) {
            if(!$(e.currentTarget).is(":focus"))
                vm.showEditIconValue = false;
        }

    }

})();